import { Tooltip } from '@branchjs/neo-components';
import React from 'react';
import { useHistory, useLocation } from 'react-router';
import { ImageService } from '../../../services/ImageService/ImageService';
import { LockedPackagingIconClasses, LockedPackagingIconStyles } from './LockedPackagingIcon.styles';

const LockedPackagingIcon = ({ route }: { route: string }) => {
  const history = useHistory();
  const location = useLocation();

  const onClick = () => {
    history.push({
      pathname: location.pathname,
      search: `modal=package-modal`,
    });
  };

  return (
    <span
      className={LockedPackagingIconClasses.container}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <Tooltip
        title={
          <span>
            <a onClick={onClick} id={`Nav-Package-${route}`}>
              Explore plans and add-ons
            </a>
            <br />
            to unlock more of Branch
          </span>
        }
        placement="right"
      >
        <img
          className="tooltip-icon"
          style={LockedPackagingIconStyles.image}
          src={ImageService.getImageUrl('/static/images/navigation/lightning-circle.svg')}
          alt="Locked"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
        />
      </Tooltip>
    </span>
  );
};

export default LockedPackagingIcon;
